export default "__VITE_ASSET__0589b09d__"